export default __webpack_public_path__ + "static/media/CompanyMainLogo.22c4d7b0.png";